import React, { FC } from 'react'

import { IconDocumentProps } from './IconDocument.types'
import * as Styled from './styles/IconDocument.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocument: FC<IconDocumentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentProps['size'],
  isResponsive = false,
}: IconDocumentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path d='M30.962 21.06h-14' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path d='M30.962 27.027h-14m14 5.973h-14' stroke='#0D0D0D' strokeLinecap='round' strokeMiterlimit='10' strokeWidth='2' />
        <path d='M11.467 13.168h7.595V6.203' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M20.707 5.268c-1.016 0-2 .361-2.774 1.02l-5.408 4.617a4.23 4.23 0 0 0-1.485 3.215v24.8c0 2.19 1.8 3.98 3.48 3.98h18.44c2.72 0 4-1.79 4-3.977V5.267H20.707Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocument
